import React, { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

import image from '../../images/img_placeholder.png';
import { filterI18nProps } from '../../utils/styledComponentsUtils';

const Image = styled.img<IProps>`
  height: 100%;
  width: 100%;
`;

interface IProps extends ImgHTMLAttributes<HTMLImageElement> {
  width?: string
}

const ImagePlaceholder: React.FC<IProps> = (props: IProps) => (
  <Image {...filterI18nProps(props)} src={image} />
);

export default ImagePlaceholder;
